import { isFunction } from "@chakra-ui/utils";
import * as ReactDOM from "react-dom";
/** This is a workaround for React Concurrent Mode issue https://github.com/facebook/react/issues/18591. Remove once it's fixed. */

export function withFlushSync(fn) {
  return function (event) {
    var flushSync = ReactDOM.flushSync;

    if (isFunction(flushSync)) {
      flushSync(function () {
        fn(event);
      });
    } else {
      fn(event);
    }
  };
}